'use strict';

require('../../style/index.css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/_antd@2.13.2@antd/lib/checkbox/style/css.js
// module id = 1021
// module chunks = 0